import _defineProperty from "/workspace/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import hyphenate from "./hyphenate-style-name";
import { validateNoMixedHand } from "./validate-no-mixed-hand";
import { prefix } from "inline-style-prefixer";
import { MultiCache } from "./cache";
export default function injectStylePrefixed(styleCache, styles, media, pseudo) {
  var cache = styleCache.getCache(media);
  var classString = "";

  for (var originalKey in styles) {
    var originalVal = styles[originalKey];

    if (originalVal === void 0 || originalVal === null) {
      continue;
    }

    if (typeof originalVal !== "object") {
      // Non-null and non-undefined primitive value
      if (process.env.NODE_ENV !== "production") {
        validateValueType(originalVal, originalKey);
      }

      var propValPair = "".concat(hyphenate(originalKey), ":").concat(originalVal);
      var key = "".concat(pseudo).concat(propValPair);
      var cachedId = cache.cache[key];

      if (cachedId !== void 0) {
        // cache hit
        classString += " " + cachedId;
        continue;
      } else {
        // cache miss
        var block = "";
        var prefixed = prefix(_defineProperty({}, originalKey, originalVal));

        for (var prefixedKey in prefixed) {
          var prefixedVal = prefixed[prefixedKey];
          var prefixedValType = typeof prefixedVal;

          if (prefixedValType === "string" || prefixedValType === "number") {
            var prefixedPair = "".concat(hyphenate(prefixedKey), ":").concat(prefixedVal);

            if (prefixedPair !== propValPair) {
              block += "".concat(prefixedPair, ";");
            }
          } else if (Array.isArray(prefixedVal)) {
            var hyphenated = hyphenate(prefixedKey);

            for (var i = 0; i < prefixedVal.length; i++) {
              var _prefixedPair = "".concat(hyphenated, ":").concat(prefixedVal[i]);

              if (_prefixedPair !== propValPair) {
                block += "".concat(_prefixedPair, ";");
              }
            }
          }
        }

        block += propValPair; // ensure original prop/val is last (for hydration)

        var id = cache.addValue(key, {
          pseudo: pseudo,
          block: block
        });
        classString += " " + id;
      }
    } else {
      // Non-null object value
      if (originalKey[0] === ":") {
        classString += " " + injectStylePrefixed(styleCache, originalVal, media, pseudo + originalKey);
      } else if (originalKey.substring(0, 6) === "@media") {
        classString += " " + injectStylePrefixed(styleCache, originalVal, originalKey.substr(7), pseudo);
      }
    }
  }

  if (process.env.NODE_ENV !== "production") {
    var conflicts = validateNoMixedHand(styles);

    if (conflicts.length) {
      conflicts.forEach(function (_ref) {
        var shorthand = _ref.shorthand,
            longhand = _ref.longhand;
        var short = JSON.stringify(_defineProperty({}, shorthand.property, shorthand.value));
        var long = JSON.stringify(_defineProperty({}, longhand.property, longhand.value)); // eslint-disable-next-line no-console

        console.warn("Styles `".concat(short, "` and `").concat(long, "` in object yielding class \"").concat(classString.slice(1), "\" may result in unexpected behavior. Mixing shorthand and longhand properties within the same style object is unsupported with atomic rendering."));
      });
    }
  } // remove leading space


  return classString.slice(1);
}

function validateValueType(value, key) {
  if (value === null || Array.isArray(value) || typeof value !== "number" && typeof value !== "string") {
    throw new Error("Unsupported style value: ".concat(JSON.stringify(value), " used in property ").concat(JSON.stringify(key)));
  }
}